import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-header" }
const _hoisted_2 = { class: "header-blox" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "header-avatar el-dropdown-link" }

import { ref, reactive } from 'vue'
import { useFullscreen } from '@vueuse/core'
// import { updateAdminPassword } from '@/api/admin/user'
import { useRouter } from 'vue-router'
import { showMessage, showModel } from '@/utils/common-util'
import FormDialog from 'components/base/FormDialog.vue'
import { Aim, ArrowDown, Expand, Fold, FullScreen, Refresh } from '@element-plus/icons-vue'
import { useStore } from '@/store'
import { ElForm } from 'element-plus'


export default /*@__PURE__*/_defineComponent({
  __name: 'admin-header',
  emits: ["foldChange"],
  setup(__props, { emit: __emit }) {

const router = useRouter()

// isFullscreen 表示当前是否处于全屏；toggle 用于动态切换全屏、非全屏
const { isFullscreen, toggle } = useFullscreen()

// 引入了菜单 Store
// const menuStore = useMenuStore()
// 引入了用户 Store
const store = useStore()

const emit = __emit

const isCollapse = ref(false)
// icon 点击事件
const handleMenuWidth = () => {
  isCollapse.value = !isCollapse.value
  emit('foldChange', isCollapse.value)
}

// 刷新页面
const handleRefresh = () => location.reload()

// 对话框是否显示
const formDialogRef = ref<InstanceType<typeof FormDialog>>()

// 下拉菜单事件处理
const handleCommand = (command: any) => {
  // 更新密码
  if (command == 'updatePassword') {
    // 显示修改密码对话框
    formDialogRef.value.open()
  } else if (command == 'logout') {
    // 退出登录
    logout()
  }
}

// 退出登录
async function logout() {
  try {
    await showModel('是否确认要退出登录？')
    await store.dispatch('login/logoutAction')
    showMessage('退出成功！')
    await router.replace('/login')
  } catch {
    // 取消确认或退出失败：不跳转
  }
}

// 表单引用
const formRef = ref<InstanceType<typeof ElForm>>()
const username = ref(store.state.login.userinfo.userName || '')
// 修改用户密码表单对象
const updatePasswordForm = reactive({
  username: username.value,
  password: '',
  rePassword: ''
})

// 规则校验
const rules = {
  username: [
    {
      required: true,
      message: '用户名不能为空',
      trigger: 'blur'
    }
  ],
  password: [
    {
      required: true,
      message: '密码不能为空',
      trigger: 'blur'
    }
  ],
  rePassword: [
    {
      required: true,
      message: '确认密码不能为空',
      trigger: 'blur'
    }
  ]
}

const onSubmit = () => {
  formRef.value?.validate((valid) => {
    if (!valid) {
      return
    }
    if (updatePasswordForm.password != updatePasswordForm.rePassword) {
      showMessage('两次密码输入不一致，请检查！', 'error')
      return
    }
    formDialogRef.value.showBtnLoading()
    store
      .dispatch('system/updatePasswordAction', { ...updatePasswordForm })
      .then(() => {
        showMessage('修改密码成功，请重新登录！')
        formDialogRef.value.closeBtnLoading()
        formDialogRef.value.close()
        router.replace('/login')
      })
      .catch(() => {
        showMessage('修改密码失败！', 'error')
      })
      .finally(() => {
        formDialogRef.value.closeBtnLoading()
      })
  })
}

// const emit = defineEmits(['submit'])
// const submit = () => emit('submit')

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "header-left",
            onClick: handleMenuWidth
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                (isCollapse.value)
                  ? (_openBlock(), _createBlock(_unref(Fold), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(Expand), { key: 1 }))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: "刷新",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "box-item-tip",
                  onClick: handleRefresh
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Refresh))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: "全屏",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "box-item-tip",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args)))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      (!_unref(isFullscreen))
                        ? (_openBlock(), _createBlock(_unref(FullScreen), { key: 0 }))
                        : (_openBlock(), _createBlock(_unref(Aim), { key: 1 }))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown, {
              class: "flex items-center justify-center",
              onCommand: handleCommand
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { command: "updatePassword" }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("修改密码", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("退出登录", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_component_el_avatar, {
                    size: 25,
                    class: "custom-avatar",
                    src: "https://img.quanxiaoha.com/quanxiaoha/f97361c0429d4bb1bc276ab835843065.jpg"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$store.state.login.userinfo.userName) + " ", 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowDown))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(FormDialog, {
          ref_key: "formDialogRef",
          ref: formDialogRef,
          title: "修改密码",
          destroyOnClose: "",
          onSubmit: onSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElForm), {
              ref_key: "formRef",
              ref: formRef,
              rules: rules,
              model: updatePasswordForm
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "用户名",
                  prop: "username",
                  "label-width": "120px",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: updatePasswordForm.username,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updatePasswordForm.username) = $event)),
                      placeholder: "请输入用户名",
                      clearable: "",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "新密码",
                  prop: "password",
                  "label-width": "120px",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "password",
                      modelValue: updatePasswordForm.password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updatePasswordForm.password) = $event)),
                      placeholder: "请输入新密码",
                      clearable: "",
                      "show-password": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "确认新密码",
                  prop: "rePassword",
                  "label-width": "120px",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "password",
                      modelValue: updatePasswordForm.rePassword,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((updatePasswordForm.rePassword) = $event)),
                      placeholder: "请确认新密码",
                      clearable: "",
                      "show-password": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    })
  ]))
}
}

})